import { ConnectionQuality, Track } from 'livekit-client';

import { IconAntennaBars3, IconAntennaBars4, IconAntennaBars5, IconAntennaBarsOff, IconMicrophone, IconMicrophoneOff, IconScreenShare, IconScreenShareOff, IconVideo, IconVideoOff } from '@tabler/icons-react/dist/cjs/tabler-icons-react';

/**
 * @internal
 */
export function getSourceIcon(source, enabled) {
	switch (source) {
		case Track.Source.Microphone:
			return enabled ? <IconMicrophone  className="lk-button-icon"/> : <IconMicrophoneOff className="lk-button-icon"/>;
		case Track.Source.Camera:
			return enabled ? <IconVideo className="lk-button-icon"/> : <IconVideoOff className="lk-button-icon"/>;
		case Track.Source.ScreenShare:
			return enabled ? <IconScreenShareOff className="lk-button-icon"/> : <IconScreenShare className="lk-button-icon"/>;
		default:
			return undefined;
	}
}

/**
 * @internal
 */
export function getConnectionQualityIcon(quality) {
	switch (quality) {
		case ConnectionQuality.Excellent:
			return <IconAntennaBars5 className="lk-button-icon"/>;
		case ConnectionQuality.Good:
			return <IconAntennaBars4 className="lk-button-icon"/>;
		case ConnectionQuality.Poor:
			return <IconAntennaBars3 className="lk-button-icon"/>;
		default:
			return <IconAntennaBarsOff className="lk-button-icon"/>;
	}
}
